"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelFactory = void 0;
const InternalLinkFactory_1 = require("./factories/InternalLinkFactory");
const DateFactory_1 = require("./factories/DateFactory");
const i_model_description_1 = require("./i-model-description");
const property_not_available_exception_1 = require("./exceptions/property-not-available-exception");
class ModelFactory {
    constructor(portalMap = new Map()) {
        const factories = new Map();
        factories.set('IInternalLink', new InternalLinkFactory_1.InternalLinkFactory(portalMap));
        factories.set('SerializableDateTime', new DateFactory_1.DateFactory());
        this.customClassFactories = factories;
    }
    fromDescription(data) {
        return this.unpackClass(data);
    }
    fromDescriptions(data) {
        const models = [];
        for (const modelDescription of data) {
            models.push(this.unpackClass(modelDescription));
        }
        return models;
    }
    unpackClass(data) {
        const unpacked = {};
        for (const functionName in data.func) {
            unpacked[functionName] = this.getCallable(functionName, data);
        }
        const factory = this.customClassFactories.get(data.class);
        if (factory !== undefined) {
            return factory.create(unpacked, data.parameters);
        }
        return unpacked;
    }
    getCallable(functionName, data) {
        const propertyName = functionName.substr(3);
        const canShowFunction = 'canShow' + propertyName;
        const value = data.func[functionName];
        let returnValue;
        if (i_model_description_1.isModelDescription(value)) {
            returnValue = this.unpackClass(value);
        }
        else if (Array.isArray(value)) {
            returnValue = this.unpackArray(value);
        }
        else {
            returnValue = value;
        }
        if (canShowFunction in data.func) {
            return () => {
                if (data.func[canShowFunction] === false) {
                    throw new property_not_available_exception_1.PropertyNotAvailableException(`Property '${propertyName}' not available`);
                }
                return returnValue;
            };
        }
        return () => {
            return returnValue;
        };
    }
    unpackArray(list) {
        return list.map(item => {
            if (i_model_description_1.isModelDescription(item)) {
                return this.unpackClass(item);
            }
            return item;
        });
    }
}
exports.ModelFactory = ModelFactory;
//# sourceMappingURL=model-factory.js.map